const CrownIcon = ({size}) => {
  const width = size ? size : "21"
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.07842 9.01753C2.73886 8.07779 2.56909 7.60792 2.64148 7.30682C2.72067 6.97748 2.95487 6.72074 3.25424 6.63509C3.52794 6.55678 3.95371 6.74602 4.80526 7.12449C5.55847 7.45925 5.93507 7.62663 6.28891 7.61732C6.6785 7.60707 7.05327 7.45083 7.3514 7.17439C7.62217 6.92332 7.80378 6.52324 8.16702 5.72306L8.96752 3.95959C9.6362 2.48653 9.97054 1.75 10.5 1.75C11.0295 1.75 11.3638 2.48653 12.0325 3.95959L12.833 5.72306C13.1962 6.52324 13.3778 6.92332 13.6486 7.17439C13.9467 7.45083 14.3215 7.60707 14.7111 7.61732C15.0649 7.62663 15.4415 7.45925 16.1947 7.12449C17.0463 6.74602 17.4721 6.55678 17.7458 6.63509C18.0451 6.72074 18.2793 6.97748 18.3585 7.30682C18.4309 7.60792 18.2611 8.07779 17.9216 9.01753L16.4621 13.0569C15.8377 14.7848 15.5255 15.6488 14.8722 16.1369C14.219 16.625 13.3747 16.625 11.6863 16.625H9.31371C7.62527 16.625 6.78105 16.625 6.12776 16.1369C5.47447 15.6488 5.16229 14.7848 4.53795 13.0569L3.07842 9.01753Z"
        stroke="#E9CA00"
        stroke-width="1.3125"
      />
      <path
        d="M10.5 12.25H10.5079"
        stroke="#E9CA00"
        stroke-width="1.75"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.125 19.25H14.875"
        stroke="#E9CA00"
        stroke-width="1.3125"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default CrownIcon;
